import moment from 'moment';
import { formatNumber } from '@angular/common';

export function computeAge(birthDate: Date) {
  const now = new Date();

  if (now.getTime() < birthDate.getTime()) {
    return { years: 0, months: 0 };
  }

  let months = now.getMonth() - birthDate.getMonth() - (now.getDate() >= birthDate.getDate() ? 0 : 1);
  let years = now.getFullYear() - birthDate.getFullYear();

  if (months < 0) {
    months = 12 + months;
    years--;
  }

  return { years, months };
}

export function parseTime(value: string): { hour: number; minute: number; second: number } {
  const result = { hour: 0, minute: 0, second: 0 }; // NB : second will always be 0

  if (isTime(value)) {
    const parts = value.split(':');
    result.hour = +parts.shift();
    result.minute = +parts.shift();
  }

  return result;
}

export function isTime(value: string) {
  return typeof value === 'string' && value.match(/^\d{2}:\d{2}$/);
}

export function formatTime(value: ({ hour: number, minute: number })): string {
  return `${formatNumber(value.hour, 'fr-FR', '2.0-0')}:${formatNumber(value.minute, 'fr-FR', '2.0-0')}`;
}

export function dateInPeriod(
  startPeriodeRef: string | Date | null,
  endPeriodeRef: string | Date | null,
  searchDate?: string | Date
): boolean {
  const search = moment(searchDate || new Date()).startOf('day');

  const start = startPeriodeRef ? moment(startPeriodeRef).startOf('day') : null;
  const end = endPeriodeRef ? moment(endPeriodeRef).endOf('day') : null;

  if (start && end) {
    return search.isSameOrAfter(start) && search.isSameOrBefore(end);
  }

  if (start && !end) {
    return search.isSameOrAfter(start);
  }

  if (!start && end) {
    return search.isSameOrBefore(end);
  }

  return true;
}

export function sortDates(dateArray: (string | Date)[], order: 'asc' | 'desc' = 'asc'): (string | Date)[] {
  return dateArray.sort((a, b) =>
    order === 'asc'
      ? moment(a).valueOf() - moment(b).valueOf()
      : moment(b).valueOf() - moment(a).valueOf()
  );
}
